var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0L8.91724 0.119629L10.8362 2.03857L7.5 5.37598L4.16382 2.03857L6.08276 0.119629L0 0L0.119629 6.08276L2.03857 4.16382L5.37476 7.5L2.03857 10.8362L0.119629 8.91724L0 15L6.08276 14.8804L4.16382 12.9614L7.5 9.62524L10.8362 12.9614L8.91724 14.8804L14.9988 15L14.8804 8.91724L12.9614 10.8362L9.62524 7.5L12.9614 4.16382L14.8804 6.08276L15 0Z",
    fill: "#47143D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomExpand);
export default __webpack_public_path__ + "static/media/zoom-expand.c52477115c5875a53be0e48df9c97241.svg";
export { ForwardRef as ReactComponent };